module.exports = __webpack_public_path__ + "img/banner_sample.c3f3ede5.png";